import React, { Component } from "react";
import { Link } from "react-router-dom";
import QVFourPhotoSection from "views/Pma/PmaEditor/Quarterly/QVFour/QVFourSecondPage/QVFourPhotoSection";
import QVFourPresentedByFooter from "views/Pma/PmaEditor/ThirdPageComponents/QVFourPresentedByFooter";
import AgentLogoHeader from "views/Pma/PmaEditor/ThirdPageComponents/AgentLogoHeader";
import QVFourPS from "views/Pma/PmaEditor/Quarterly/QVFour/QVFourSecondPage/QVFourPS";
import YETwoShortenedMarketTable from "views/Pma/PmaEditor/YearEnd2022/YETwo/YETwoSecondPage/YETwoShortenedMarketTable";
import MQThreeAvailableHomes from "views/Pma/PmaEditor/ThirdPageComponents/MQThreeAvailableHomes";
import QRCode from "views/Pma/PmaEditor/ThirdPageComponents/QRCode";
import MarketIndicators from "views/Pma/PmaEditor/YearEnd2022/YETwo/YETwoSecondPage/YETwoMarketIndicators";
import QVFourEmailAndWebsiteFooter from "views/Pma/PmaEditor/SecondPageComponents/QVFourEmailAndWebsiteFooter";

class YETwoSecondRight extends Component {
  sortByStatus = (propList, getExtendedTable, alwaysExtendedTable) => {
    const { mlsAreaID } = this.props.currentArea;
    const { listgenUserID } = this.props.agentData;

    let {
      activePhotoDetailsList,
      contingentPhotoDetailsList,
      pendingPhotoDetailsList,
      preSoldPhotoDetailsList,
      recentSoldPhotoDetailsList,
      agentFilteredPhotoDetailsList,
      comingSoonSoldPhotoDetailsList,
    } = this.props.quarterlyAreaTable;
    console.log("second right props", this.props.quarterlyAreaTable);
    const filterOutProperties = (dataList) => {
      if (mlsAreaID === "CCA-4500G") {
        let filteredList = dataList.filter((property) => {
          let Laurel323 =
            property.streetNumber === "323" &&
            property.streetName.includes("Laurel") &&
            property.status.includes("Coming Soon");
          let GlenHollow7 =
            property.streetNumber === "7" &&
            property.streetName.includes("Glen Hollow");

          return !Laurel323 && !GlenHollow7;
        });
        return filteredList;
      }
      return dataList;
      // }
    };

    let sold = recentSoldPhotoDetailsList
      ? filterOutProperties(recentSoldPhotoDetailsList)
      : [];
    let pend = pendingPhotoDetailsList
      ? filterOutProperties(pendingPhotoDetailsList)
      : [];
    let cont = contingentPhotoDetailsList
      ? filterOutProperties(contingentPhotoDetailsList)
      : [];
    let comingSoonList = [];

    if (
      (listgenUserID === "107263" ||
        listgenUserID === "109954" ||
        mlsAreaID === "ALA-3900AK" ||
        mlsAreaID === "CCA-4500G" ||
        mlsAreaID === "CCA-4500X" ||
        mlsAreaID === "CCA-4400P") &&
      comingSoonSoldPhotoDetailsList &&
      Object.keys(comingSoonSoldPhotoDetailsList).length > 0
    ) {
      comingSoonList = [...comingSoonSoldPhotoDetailsList];
    }
    console.log("comingSoonList", comingSoonList);
    let active = activePhotoDetailsList
      ? filterOutProperties(activePhotoDetailsList)
      : [];
    let laterSold = preSoldPhotoDetailsList
      ? filterOutProperties(preSoldPhotoDetailsList)
      : [];
    let agentsProps = agentFilteredPhotoDetailsList
      ? filterOutProperties(agentFilteredPhotoDetailsList)
      : [];
    let last45DaysSum =
      (agentFilteredPhotoDetailsList
        ? filterOutProperties(agentFilteredPhotoDetailsList).length
        : 0) +
      (activePhotoDetailsList
        ? filterOutProperties(activePhotoDetailsList).length
        : 0) +
      (contingentPhotoDetailsList
        ? filterOutProperties(contingentPhotoDetailsList).length
        : 0) +
      (pendingPhotoDetailsList
        ? filterOutProperties(pendingPhotoDetailsList).length
        : 0) +
      (recentSoldPhotoDetailsList
        ? filterOutProperties(recentSoldPhotoDetailsList).length
        : 0);

    let remainderPreSold = 12 - last45DaysSum;

    const sortStartingJan1 = (data) => {
      // Filter sold properties starting from January 1, 2025

      let soldFromJan1 = data
        .filter((x) => x.status === "Sold")
        .filter((x) => {
          if (x.saleDate === "-" || !x.saleDate) return false;
          const saleDate = new Date(x.saleDate);
          const jan1_2025 = new Date("2025-01-01");
          return saleDate >= jan1_2025;
        })
        .sort((a, b) => new Date(b.saleDate) - new Date(a.saleDate));
      // Get non-sold properties (Active, Coming Soon, Pending, Contingent)
      let nonSoldProps = data.filter((x) => x.status !== "Sold");
      // Combine non-sold properties with sold properties from Jan 1, 2025
      let combined = [...nonSoldProps, ...soldFromJan1];
      // Remove duplicates
      let uniqueProps = combined.filter(
        (obj1, i, arr) =>
          arr.findIndex(
            (obj2) =>
              obj2.streetNumber === obj1.streetNumber &&
              obj2.streetName === obj1.streetName &&
              obj2.status === obj1.status &&
              obj2.streetSuffix === obj1.streetSuffix &&
              obj2.unitNumber === obj1.unitNumber &&
              obj2.squareFeet === obj1.squareFeet,
          ) === i,
      );
      let updatedList = [...uniqueProps];
      let onlyAgentProps = updatedList.filter(
        (prop) => prop.listingAgentName === "Ann Marie Nugent",
      );
      let onlyActivePendingContingent = updatedList.filter(
        (prop) =>
          prop.status === "Active" ||
          prop.status === "Active - Coming Soon" ||
          prop.status === "Coming Soon" ||
          prop.status === "Pending" ||
          prop.status === "Contingent",
      );
      let onlySoldProps = updatedList.filter(
        (prop) =>
          prop.status === "Sold" &&
          prop.listingAgentName !== "Ann Marie Nugent",
      );
      return [
        ...onlyActivePendingContingent,
        ...onlySoldProps,
        ...onlyAgentProps,
      ];
    };
    const sortByStatusThenDate = (data) => {
      let sortedSolds = data
        .filter((x) => x.status === "Sold")
        .sort((a, b) => new Date(b.saleDate) - new Date(a.saleDate));
      let newConstructed = [
        ...data.filter(
          (x) =>
            x.status === "Active - Coming Soon" || x.status === "Coming Soon",
        ),
        ...data.filter((x) => x.status === "Active"),
        ...data.filter(
          (x) => x.status === "Pending" || x.status === "Contingent",
        ),
        ...sortedSolds,
      ];

      let uniqueProps = newConstructed.filter(
        (obj1, i, arr) =>
          arr.findIndex(
            (obj2) =>
              obj2.streetNumber === obj1.streetNumber &&
              obj2.streetName === obj1.streetName &&
              obj2.status === obj1.status &&
              obj2.streetSuffix === obj1.streetSuffix &&
              obj2.unitNumber === obj1.unitNumber &&
              obj2.squareFeet === obj1.squareFeet,
          ) === i,
      );
      return uniqueProps;
    };
    let extraProperties;
    if (mlsAreaID === "ALA-3900AK") {
      extraProperties = 14;
    }
    const sortByStatusThenPropType = (data) => {
      let singleFamHomes = data
        .filter(
          (x) => x.status === "Sold" && x.propertyType === "Single Family Home",
        )
        .sort((a, b) => new Date(b.saleDate) - new Date(a.saleDate));
      let townhomeSolds = data
        .filter((x) => x.status === "Sold" && x.propertyType === "Townhouse")
        .sort((a, b) => new Date(b.saleDate) - new Date(a.saleDate));
      let sortedSolds = [...singleFamHomes, ...townhomeSolds];
      let newConstructed = [
        ...data.filter(
          (x) =>
            x.status === "Active" ||
            x.status === "Active - Coming Soon" ||
            x.status === "Coming Soon",
        ),
        ...data.filter(
          (x) => x.status === "Pending" || x.status === "Contingent",
        ),
        ...sortedSolds,
      ];
      let uniqueProps = newConstructed.filter(
        (obj1, i, arr) =>
          arr.findIndex(
            (obj2) =>
              obj2.streetNumber === obj1.streetNumber &&
              obj2.streetName === obj1.streetName &&
              obj2.status === obj1.status,
          ) === i,
      );
      return uniqueProps;
    };
    let trueSort1 = [
      ...agentsProps,
      ...active,
      ...pend,
      ...cont,
      ...sold,
      ...laterSold.slice(0, remainderPreSold),
    ];

    if (listgenUserID === "100075") {
      trueSort1 = [
        ...active,
        ...agentsProps,
        ...pend,
        ...cont,
        ...sold,
        ...laterSold.slice(0, remainderPreSold),
      ];
    } else if (mlsAreaID === "CCA-4400P") {
      trueSort1 = [
        ...comingSoonList,
        ...agentsProps,
        ...active,
        ...pend,
        ...cont,
        ...sold,
        ...laterSold.slice(0, remainderExtended),
      ];
    }

    let extendedTrueSortJan1 = [
      ...comingSoonList,
      ...agentsProps,
      ...active,
      ...pend,
      ...cont,
      ...sold,
      ...laterSold,
    ];

    let trueSort =
      listgenUserID === "109954"
        ? sortStartingJan1(extendedTrueSortJan1.slice(0, 19))
        : sortByStatusThenDate(trueSort1);

    if (
      (last45DaysSum < 12 && listgenUserID !== "101268") ||
      alwaysExtendedTable
    ) {
      if (getExtendedTable) {
        return false;
      } else if (mlsAreaID === "SMA-392" || mlsAreaID === "CCA-4500F") {
        let propTypeSort = sortByStatusThenPropType(trueSort1);
        return propTypeSort;
      } else {
        return trueSort;
      }
    } else {
      let today = new Date();
      let date45DaysAgo = new Date(
        today.setDate(today.getDate() - 45),
      ).toISOString();
      let last45DayDates = trueSort.filter(
        (x) =>
          (x.saleDate !== "-" && x.saleDate > date45DaysAgo) ||
          x.status === "Active" ||
          x.status === "Active - Coming Soon" ||
          x.status === "Contingent" ||
          x.status === "Pending",
      );
      let remainderExtended = 18 - last45DayDates.length;
      let extendedTrueSort1 = [
        ...agentsProps,
        ...active,
        ...pend,
        ...cont,
        ...sold,
        ...laterSold.slice(0, remainderExtended),
      ];

      if (listgenUserID === "107263") {
        extendedTrueSort1 = [
          ...comingSoonList,
          ...agentsProps,
          ...active,
          ...pend,
          ...cont,
          ...sold,
          ...laterSold.slice(0, remainderExtended),
        ];
      } else if (
        mlsAreaID === "ALA-3900AD" ||
        mlsAreaID === "CCA-4500G" ||
        mlsAreaID === "ALA-3900AK" ||
        mlsAreaID === "CCA-4400P"
      ) {
        extendedTrueSort1 = [
          ...comingSoonList,
          ...agentsProps,
          ...active,
          ...pend,
          ...cont,
          ...sold,
          ...laterSold.slice(0, remainderExtended),
        ];
      } else if (listgenUserID === "109954") {
        extendedTrueSort1 = [
          ...comingSoonList,
          ...agentsProps,
          ...active,
          ...pend,
          ...cont,
          ...sold,
          ...laterSold,
        ];
      }

      let extendedTrueSort;

      extendedTrueSort =
        listgenUserID === "109954"
          ? sortStartingJan1(extendedTrueSort1.slice(0, 19))
          : sortByStatusThenDate(extendedTrueSort1.slice(0, 14));

      if (getExtendedTable) {
        return true;
      } else {
        return extendedTrueSort.slice(
          0,
          extraProperties ? extraProperties : 12,
        );
      }
    }
    // return propList.slice(0, 19);
  };

  render() {
    const {
      currentArea,
      agentData,
      printVersion,
      fromEditor,
      version,
      hoData,
      mlsAreas,
      demoAccountHOName,
      quarterlyAreaTable,
      quarterlyCityTable,
      MQCityDetails,
      isDemo,
      coverPageDetails,
      showAllEditButtons,
    } = this.props;
    const { listgenUserID } = agentData;
    const { mlsAreaID } = currentArea;
    let { currentSoldListings } = quarterlyAreaTable;
    let useExtendedTable = false;
    let useHotBoxes = false;

    let useCondosOnly = false;
    if (mlsAreaID === "CCA-4500F") {
      useCondosOnly = true;
    }
    let useTownhousesOnly = false;
    if (mlsAreaID === "SMA-392") {
      useTownhousesOnly = true;
    }

    if (listgenUserID === "x105886" || listgenUserID === "109954") {
      useExtendedTable = true;
    }
    if (mlsAreaID === "SMA-392" || mlsAreaID === "CCA-4500F") {
      useHotBoxes = true;
    }
    let sorted =
      currentSoldListings && currentSoldListings
        ? this.sortByStatus(currentSoldListings, false, useExtendedTable)
        : [];

    let useCity = false;
    if (mlsAreaID === "SBA-40F" || mlsAreaID === "SBA-40G") {
      useCity = true;
    }
    let showAvailableHomes = true;
    let useForNovember = false;

    if (useForNovember) {
      return (
        <div
          className={`${
            version === "year-end-2022" ? "ye2" : "qv4"
          }-second-right`}
        >
          <YETwoShortenedMarketTable
            quarterlyCityTable={quarterlyCityTable}
            currentArea={currentArea}
            quarterlyAreaTable={
              useCity ? quarterlyCityTable : quarterlyAreaTable
            }
            useCity="false"
            hoData={hoData}
            agentData={agentData}
            MQCityDetails={MQCityDetails}
            lastMidQuarterlyPrintDate={
              quarterlyAreaTable.lastMidQuarterlyPrintDate
            }
            //printDate="Nov 1, 2021"
            printVersion={printVersion}
            currentSoldListings={currentSoldListings}
            sorted={sorted}
            useExtendedTable={useExtendedTable}
            tableMonthStyles="november-table-container"
          />

          {useHotBoxes && (
            <MarketIndicators
              quarterlyAreaTable={quarterlyAreaTable}
              currentArea={currentArea}
              useCity={useCity}
              printVersion={printVersion}
              quarterlyCityTable={quarterlyCityTable}
              agentData={agentData}
              useSecondMarketIndicators={true}
              useSeparatedPropertyTypesCondoTownhouse={false}
              useSeparatedPropertyTypesCondos={useCondosOnly}
              useSeparatedPropertyTypesTownhouses={useTownhousesOnly}
              from3rdPage={true}
            />
          )}

          <QVFourEmailAndWebsiteFooter
            agentData={agentData}
            currentArea={currentArea}
            printVersion={printVersion}
          />
        </div>
      );
    } else {
      return (
        <div
          className={`${
            version === "year-end-2022" ? "ye2" : "qv4"
          }-second-right`}
        >
          <AgentLogoHeader
            agentData={agentData}
            currentArea={currentArea}
            printVersion={printVersion}
          />
          {fromEditor && showAllEditButtons && (
            <Link
              to={`/mailpro/${mlsAreaID}`}
              style={{
                position: "absolute",
                right: "-279px",
                top: "80px",
                backgroundColor: "#4e85af",
                color: "white",
                padding: "8px 16px",
                textDecoration: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              <p>Go to MailPro to Edit Global Note</p>
            </Link>
          )}

          {hoData &&
            hoData.changeDetails &&
            Object.keys(hoData.changeDetails).length > 1 && (
              <QVFourPS
                agentData={agentData}
                hoData={hoData}
                currentArea={currentArea}
                mlsAreas={mlsAreas}
                version={version}
                printVersion={printVersion}
                mailingNum="qv4"
                demoAccountHOName={demoAccountHOName}
                isDemo={isDemo}
              />
            )}

          <QRCode
            hoData={hoData}
            agentData={agentData}
            currentArea={currentArea}
            printVersion={printVersion}
          />

          {listgenUserID === "x" ? (
            <QVFourPhotoSection
              currentArea={currentArea}
              agentData={agentData}
              printVersion={printVersion}
              version={version}
              hoData={hoData}
              currentSoldListings={quarterlyAreaTable.currentSoldListings}
            />
          ) : (
            <YETwoShortenedMarketTable
              quarterlyCityTable={quarterlyCityTable}
              currentArea={currentArea}
              quarterlyAreaTable={
                useCity ? quarterlyCityTable : quarterlyAreaTable
              }
              useCity="false"
              hoData={hoData}
              agentData={agentData}
              MQCityDetails={MQCityDetails}
              lastMidQuarterlyPrintDate={
                quarterlyAreaTable.lastMidQuarterlyPrintDate
              }
              //printDate="Nov 1, 2021"
              printVersion={printVersion}
              currentSoldListings={currentSoldListings}
              sorted={sorted}
              useExtendedTable={useExtendedTable}
            />
          )}

          {!useExtendedTable && !useHotBoxes && showAvailableHomes && (
            <MQThreeAvailableHomes
              currentArea={currentArea}
              quarterlyAreaTable={quarterlyAreaTable}
              quarterlyCityTable={quarterlyCityTable}
              MQCityDetails={MQCityDetails}
              hoData={hoData}
              agentData={agentData}
              useCity={useCity}
              printVersion={printVersion}
            />
          )}
          {useHotBoxes && (
            <MarketIndicators
              quarterlyAreaTable={quarterlyAreaTable}
              currentArea={currentArea}
              useCity={useCity}
              printVersion={printVersion}
              quarterlyCityTable={quarterlyCityTable}
              agentData={agentData}
              useSecondMarketIndicators={true}
              useSeparatedPropertyTypesCondoTownhouse={false}
              useSeparatedPropertyTypesCondos={useCondosOnly}
              useSeparatedPropertyTypesTownhouses={useTownhousesOnly}
              from3rdPage={true}
            />
          )}

          <QVFourPresentedByFooter
            agentData={agentData}
            currentArea={currentArea}
            currentSoldListings={currentSoldListings}
            printVersion={printVersion}
            coverPageDetails={coverPageDetails}
          />
        </div>
      );
    }
  }
}

export default YETwoSecondRight;
